module.exports = __webpack_public_path__ + "img/cash-dark.6ed0fcda.svg";